import { Router } from '..';

export interface Ipv4GroupPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: Ipv4Group[];
}

export interface Ipv4Group {
  id_grupoipv4?: string;

  nombre: string;
  codigo: string;
  estado: boolean;
  es_bras: boolean
  ipv_4: string; // red
  gateway: string; // red
  cidr: string; // mascara
  ips_disponibles: IPDisponibles[];

  total_ips?:number
  total_ips_used?:number

  fecha_creacion?: string;
  fecha_modificacion?: string;
  numero_referencia?: string;

  ///* fk
  routers: string;
  tipo_uso: string; // choice
  bras?: string|null
  router_data?: Router[];

  descripcion?:string
  // gateway:string
  mascara?:string
  vlan?:string
}

export interface IPDisponibles {
  ip: string;
  estado: boolean; // true = available, false = used
}

export enum TipoUsoIPv4 {
  ESTATICO = 'ESTÁTICO',
  DINAMICO = 'DINÁMICO',
}

export const SubmascaraRedEnum = [
  "/19",
  "/20",
  "/21",
  "/22",
  "/23",
  "/24",
  "/25",
  "/26",
  "/27",
  "/28",
  "/29",
  "/30",
  "/31",
  "/32",
]